// extracted by mini-css-extract-plugin
module.exports = {"messengerBtn":"_1NFcP","messengerOuter":"_3DDX_","messContent":"_2l1Md","messageEnter":"_2vpt1"};